import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestInternalBankReplenish } from "./internalBankReplenish.request";

const useInternalBankReplenish = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchInternalBank = useRefetchQuery(["internal-bank"]);
  const refetchInternalBankHistory = useRefetchQuery(["internal-bank-history"]);

  return useMutation({
    mutationFn: requestInternalBankReplenish,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchInternalBank();
      refetchInternalBankHistory();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useInternalBankReplenish;
